import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTitleDecor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "animatedSticks",
	width: 28,
	height: 27,
	viewBox: "0 0 28 27",
	fill: "none",
	className: "animate",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", { children: "\n        .animate .stick {\n            opacity: 0;\n            transform: scale(0.8) translateY(10px);\n            transform-origin: center;\n            animation: pop-in 0.3s ease forwards;\n        }\n        .animate .stick1 {\n            animation-delay: 0s;\n        }\n        .animate .stick2 {\n            animation-delay: 0.1s;\n        }\n        .animate .stick3 {\n            animation-delay: 0.2s;\n        }\n\n        @keyframes pop-in {\n            from {\n                opacity: 0;\n                transform: scale(0.8) translateY(10px);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale(1) translateY(0);\n            }\n        }\n\n        .animate .stick {\n        }\n    " }),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6732_93464)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "stick stick1",
					d: "M27.7199 23.0604L27.7107 22.9856C27.6531 22.5168 27.2264 22.1834 26.7576 22.2409L20.3482 23.0279C19.8794 23.0855 19.546 23.5122 19.6036 23.981L19.6128 24.0558C19.6703 24.5246 20.097 24.858 20.5658 24.8004L26.9752 24.0134C27.444 23.9559 27.7774 23.5292 27.7199 23.0604Z",
					fill: "#003399"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "stick stick2",
					d: "M12.0354 16.3962L21.9459 4.24476C22.2471 3.87551 22.1919 3.33204 21.8226 3.03088L21.7817 2.99754C21.4125 2.69639 20.869 2.75159 20.5679 3.12085L10.6574 15.2723C10.3562 15.6415 10.4114 16.185 10.7807 16.4862L10.8216 16.5195C11.1908 16.8207 11.7343 16.7655 12.0354 16.3962Z",
					fill: "#003399"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "stick stick3",
					d: "M2.01835 2.25274L2.63848 2.20937C3.06476 2.43638 3.25295 2.89531 3.20307 3.58616C2.98882 6.60741 2.75397 8.81181 2.4985 10.1994C2.38917 10.7962 2.03988 11.022 1.45063 10.8769L1.22766 10.8207C1.06106 10.7792 0.916582 10.6757 0.823676 10.5313C0.730771 10.3869 0.696435 10.2125 0.727668 10.0437C1.1621 7.68688 1.4075 5.30927 1.46388 2.91089C1.4653 2.84797 1.48047 2.78579 1.50838 2.72848C1.53628 2.67117 1.57628 2.62006 1.6257 2.57855L2.01835 2.25274Z",
					fill: "#003399"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6732_93464",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24.1121,
				height: 26.3726,
				fill: "white",
				transform: "translate(26.3125 0.553711) rotate(86)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTitleDecor);
export { ForwardRef as ReactComponent };
